/* ---------------------------------------------------------------------------
   sc-escada-bf v4 — Black Friday da Stella (22/10/2026): pulseira gratis escolhida
   (2 pecas quaisquer = 1 Dettaglio, Piccolo ou Amalfi) + presente por valor pago
   Config e estilos: sections/sc-escada-bf.liquid. Leia o cabecalho de la antes
   de mexer aqui.

   O QUE ESTE ARQUIVO FAZ
     - Soma o valor PAGO do carrinho (linhas com desconto, menos desconto de
       pedido; sem presentes, sem brindes, sem frete) e decide os degraus.
     - Presente a escolha (26/10, o que esta valendo): R$ 999 pagos = a cliente
       escolhe UM presente (camiseta ou garrafa) no card. Nada entra sozinho; a
       escolha e o tamanho ficam guardados (m.esc / m.tam). Nao trava o checkout:
       so mostra o aviso "voce ainda nao escolheu seu presente" acima do botao.
       Tirou o presente do carrinho: volta a escolher. "Trocar pela ..." troca.
       Os textos falam em R$ 1.000 (d.meta, o minimo arredondado de R$ 10 em R$ 10);
       quem libera e o minimo (d.min, R$ 999).
     - Modo (29/10): CFG.modo "live" = tema da live (3a gratis + presente); "mes" = tema do
       mes (so a 3a gratis, o Liquid nao manda degraus). No mes, presente que ficou no
       carrinho sai como orfao e a gaveta avisa que a live terminou.
     - Escada (setting "Presente a escolha" desligado): presente sem tamanho entra
       sozinho; com tamanho abre o seletor no card e trava o checkout da gaveta
       ate a pessoa escolher ou dizer que nao quer.
     - Caiu abaixo do valor: o presente sai. Subiu de novo: volta (o mesmo).
     - Pulseira gratis: com 2 pecas pagas, mostra o seletor na vaga do fim
       da lista de itens e poe a escolhida no carrinho (_pulseira_bf). Menos de
       2 pecas: ela sai. Quem zera o preco e o desconto da Shopify.
     - Desenha o card dos presentes no topo da gaveta, a vaga da pulseira no fim
       da lista e o aviso acima do botao de checkout.
     - Na PDP, desenha o card da Black (snippets/sc-col-extra, [data-scbfc], refeito em
       31/10): regua das pecas, pulseiras gratis, regua do presente na live (desenharPdp).
     - Fora da PDP e do /cart, desenha a barra "peca 1 + peca 2 = presente" fixa no
       rodape (desenharBarra, 26/10).

   COMO O CARRINHO E OBSERVADO (sem interceptar fetch): theme.pubsub
   cartUpdate, cart:refresh / cart:build / cart:change e a carga da pagina. Em
   cada sinal le /cart.js e corrige, uma conferencia por vez. A gaveta e
   redesenhada pelo proprio tema; o card e recolocado porque o tema troca o
   HTML inteiro do painel.
   --------------------------------------------------------------------------- */
(function () {
  'use strict';
  if (window.scEscadaBF) return;

  var CFG;
  try { CFG = JSON.parse(document.getElementById('sc-bf-cfg').textContent); } catch (e) { return; }
  if (!CFG || !CFG.degraus) return;
  var PUL = (CFG.pul && CFG.pul.ativo && CFG.pul.modelos && CFG.pul.modelos.length) ? CFG.pul : null;
  if (!CFG.degraus.length && !PUL) return;   /* presentes esgotados: a pulseira gratis continua */

  var CHAVE = 'sc-escada-bf-v2';
  var MARCA = '_presente_bf';
  var TESTE = !!CFG.teste;
  var LIVE = CFG.modo === 'live';
  if (TESTE && window.console) console.warn('sc-escada-bf: MODO DE TESTE LIGADO. O presente pode aparecer cobrado. Desligue antes de publicar.');
  var raiz = document.documentElement;

  /* cada degrau tem uma lista de opcoes (produtos). Escada: uma opcao por degrau. Presente a
     escolha (d.escolha, decisao do Bruno 26/10): um degrau so, e a cliente escolhe UMA opcao.
     Os campos do degrau (nome, img, preco...) servem aos textos: com varias opcoes, o nome vira
     "Camiseta ou garrafa" e o preco e o da opcao mais cara ("presente de ate R$ X"). */
  CFG.degraus.forEach(function (d) {
    d.opcoes = d.opcoes || [];
    d.opcoes.forEach(function (o) { o.unica = o.variantes.length === 1; o.artigo = o.artigo || 'a'; });
    d.escolha = !!d.escolha;
    var o0 = d.opcoes[0] || {};
    d.nome = d.opcoes.length > 1 ? maiuscula(d.opcoes.map(function (o) { return String(o.nome).toLowerCase(); }).join(' ou ')) : o0.nome;
    d.titulo = o0.titulo; d.url = o0.url; d.img = o0.img; d.artigo = o0.artigo;
    d.preco = d.opcoes.reduce(function (mx, o) { return Math.max(mx, o.preco || 0); }, 0);
    /* valor que aparece nos textos: o minimo arredondado para cima de R$ 10 em R$ 10. A regra libera em
       R$ 999, o card fala em R$ 1.000 e o "faltam" conta ate R$ 1.000 (pedido do Bruno, 26/10) */
    d.meta = Math.ceil(d.min / 1000) * 1000;
  });
  CFG.degraus = CFG.degraus.filter(function (d) { return d.opcoes.length; });
  CFG.degraus.sort(function (a, b) { return a.min - b.min; });

  /* ---------- memoria do carrinho ---------- */
  function ler() {
    try { return JSON.parse(window.localStorage.getItem(CHAVE) || '{}') || {}; } catch (e) { return {}; }
  }
  function gravar(m) {
    try { window.localStorage.setItem(CHAVE, JSON.stringify(m)); } catch (e) {}
  }
  function limpa(m) {
    ['posto', 'recusado', 'tam', 'travado', 'esgotado', 'perdido', 'esc'].forEach(function (k) { if (!m[k]) m[k] = {}; });
    return m;
  }

  /* presente da live que saiu no tema do mes: o aviso fica 30 min na gaveta */
  function marcarSaiuLive() { try { window.sessionStorage.setItem(CHAVE + '-saiu', String(Date.now())); } catch (e) {} }
  function saiuLiveRecente() {
    try { var t = Number(window.sessionStorage.getItem(CHAVE + '-saiu') || 0); return t && Date.now() - t < 30 * 60 * 1000; } catch (e) { return false; }
  }

  /* ---------- rede ---------- */
  function pedir(url, corpo) {
    var op = { credentials: 'same-origin', cache: 'no-store', headers: { 'Accept': 'application/json' } };
    if (corpo) {
      op.method = 'POST';
      op.headers['Content-Type'] = 'application/json';
      op.body = JSON.stringify(corpo);
    }
    return fetch(url, op).then(function (r) {
      if (!r.ok) { var e = new Error('sc-bf ' + r.status); e.status = r.status; throw e; }
      return r.json();
    });
  }
  function mudar(chave, qtd) { return pedir('/cart/change.js', { id: chave, quantity: qtd }); }

  /* ---------- leitura do carrinho ---------- */
  function degrauDe(it) {
    return it.properties && it.properties[MARCA] ? parseInt(it.properties[MARCA], 10) : 0;
  }
  /* produto que e presente (camiseta, garrafa) fica fora da conta mesmo quando comprado:
     nao vira peca nem valor. A colecao "BF 2026 - conta na promocao" (o 'compre' dos
     descontos da Shopify) tambem tira eles; sem isso a cliente compraria a camiseta e
     ela mesma liberaria o presente. */
  var PRESENTE = {};
  (CFG.fora || []).forEach(function (id) { if (id) PRESENTE[String(id)] = true; });
  CFG.degraus.forEach(function (d) { d.opcoes.forEach(function (o) { PRESENTE[String(o.produto)] = true; }); });
  function foraDaConta(it) {
    return !!(degrauDe(it) || (it.properties && it.properties._brinde) || PRESENTE[String(it.product_id)]);
  }
  /* valor pago, em centavos: linhas ja com desconto de produto, menos desconto de pedido.
     Presente, brinde e frete ficam fora. A pulseira gratis marcada tambem fica fora (no
     preview, antes do desconto existir, ela vem cobrada e liberaria a camiseta antes da
     hora); so conta se a Shopify deu outra best seller de graca e cobrou a marcada. */
  function valorPago(cart) {
    var v = 0;
    (cart.items || []).forEach(function (it) {
      if (foraDaConta(it)) return;
      if (ehPul(it) && !bestGratis(cart, it)) return;
      v += Number(it.final_line_price) || 0;
    });
    (cart.cart_level_discount_applications || []).forEach(function (a) {
      v -= Number(a.total_allocated_amount) || 0;
    });
    return Math.max(0, v);
  }
  function linhasDe(cart, n) {
    return (cart.items || []).filter(function (it) { return degrauDe(it) === n; });
  }

  /* ---------- pulseira gratis: 2 pecas pagas = 1 best seller escolhida ----------
     Quem da de graca e o desconto automatico da Shopify (compre 2, ganhe 1 best seller).
     Conta qualquer produto (PUL.todos) ou so a colecao escolhida. Aqui so se escolhe,
     poe e tira a linha marcada. */
  var MARCA_P = '_pulseira_bf';
  var CONTA = {}, BEST = {};
  if (PUL) {
    (PUL.conta || []).forEach(function (id) { CONTA[String(id)] = true; });
    PUL.modelos.forEach(function (md) { md.cores.forEach(function (c) { BEST[String(c.pid)] = true; }); });
  }
  function ehPul(it) { return !!(it.properties && it.properties[MARCA_P]); }
  function linhasPul(cart) { return (cart.items || []).filter(ehPul); }
  /* pecas pagas: qualquer produto (ou so a colecao), sem a gratis marcada, sem presentes,
     brindes e vale-presente */
  function pecasPagas(cart) {
    var n = 0;
    (cart.items || []).forEach(function (it) {
      if (ehPul(it) || foraDaConta(it) || it.gift_card) return;
      if (!PUL.todos && !CONTA[String(it.product_id)]) return;
      n += it.quantity || 1;
    });
    return n;
  }
  /* best seller que a Shopify ja deu de graca: alocacao de desconto do tamanho de uma unidade */
  function bestGratis(cart, fora) {
    var achou = null;
    (cart.items || []).forEach(function (it) {
      if (achou || it === fora || !BEST[String(it.product_id)]) return;
      (it.line_level_discount_allocations || []).forEach(function (a) {
        if (!achou && it.original_price > 0 && Number(a.amount) >= it.original_price) achou = it;
      });
    });
    return achou;
  }
  function assinatura(cart) {
    var cods = (cart.discount_codes || [])
      .filter(function (d) { return d.applicable; })
      .map(function (d) { return String(d.code).toUpperCase(); }).sort().join(',');
    var ids = (cart.items || [])
      .filter(function (it) { return !degrauDe(it) && !ehPul(it); })
      .map(function (it) { return it.variant_id + 'x' + it.quantity; }).sort().join(',');
    return cods + '|' + ids;
  }
  function opcaoDe(d, pid) {
    for (var i = 0; i < d.opcoes.length; i++) if (String(d.opcoes[i].produto) === String(pid)) return d.opcoes[i];
    return null;
  }
  /* opcao disponivel: alguma variante com estoque e sem 422 recente ao adicionar (30 min) */
  function opDisp(m, o) {
    var t = m.esgotado['p' + o.produto];
    if (t && Date.now() - t < 30 * 60 * 1000) return false;
    return o.variantes.some(function (v) { return v.disp; });
  }
  function opcoesDisp(m, d) { return d.opcoes.filter(function (o) { return opDisp(m, o); }); }
  function esgotado(m, d) { return !opcoesDisp(m, d).length; }
  /* textos fora do card (barra, PDP, cabecalhos): so os presentes com estoque; sem leitura ainda, todos */
  function opsVis(d) {
    if (!d.escolha || !ultimo) return d.opcoes;
    var o = opcoesDisp(ultimo.m, d);
    return o.length ? o : d.opcoes;
  }
  function nomeD(d) {
    var o = opsVis(d);
    return o.length > 1 ? maiuscula(o.map(function (x) { return String(x.nome).toLowerCase(); }).join(' ou ')) : o[0].nome;
  }
  function imgD(d) { return opsVis(d)[0].img || d.img; }
  function precoD(d) { return Math.max.apply(null, opsVis(d).map(function (x) { return x.preco || 0; })); }
  /* a opcao que vale: na escada, a unica; no presente a escolha, a que a cliente escolheu */
  function escolhida(m, d) {
    if (!d.escolha) return d.opcoes[0];
    var o = m.esc && m.esc[d.n] ? opcaoDe(d, m.esc[d.n]) : null;
    return o && opDisp(m, o) ? o : null;
  }
  /* degraus que aparecem: os configurados, menos os esgotados (some a foto, some o degrau) */
  function ativos(cart, m) {
    return CFG.degraus.filter(function (d) { return linhasDe(cart, d.n).length || !esgotado(m, d); });
  }

  /* ---------- a regra: uma correcao por volta ---------- */
  var denovo = false;
  var ultimo = null;   /* { cart, m } da ultima leitura, usado para desenhar */

  function conferirCarrinho() {
    return pedir('/cart.js').then(function (cart) {
      var m = ler();
      if (m.token && m.token !== cart.token) m = {};
      m.token = cart.token;
      limpa(m);

      var v = valorPago(cart);
      var sig = assinatura(cart);
      var i, d, linhas, l;

      /* presente que nao bate com a configuracao (degrau removido ou produto trocado): sai */
      var orfas = (cart.items || []).filter(function (it) {
        var g = degrauDe(it);
        return g && !CFG.degraus.some(function (x) { return x.n === g && !!opcaoDe(x, it.product_id); });
      });
      if (orfas.length) {
        if (!LIVE) marcarSaiuLive();                               /* tema do mes: a live terminou */
        denovo = true; return mudar(orfas[0].key, 0).then(function () { return true; });
      }

      /* pulseira gratis: uma linha, uma unidade, so com 2 pecas pagas */
      if (PUL) {
        var lp = linhasPul(cart), p0 = lp[0], np = pecasPagas(cart);
        var foraP = lp.filter(function (it) { return !BEST[String(it.product_id)]; })[0];
        if (foraP) { denovo = true; return mudar(foraP.key, 0).then(function () { return true; }); }
        if (lp.length > 1) { denovo = true; return mudar(lp[1].key, 0).then(function () { return true; }); }
        if (p0 && p0.quantity > 1) { denovo = true; return mudar(p0.key, 1).then(function () { return true; }); }
        /* caiu para menos de 2 pecas: sai, e a escolha fica guardada no seletor */
        if (p0 && np < 2) {
          m.pulSel = p0.variant_id; gravar(m); denovo = true;
          return mudar(p0.key, 0).then(function () { return true; });
        }
        /* TRAVA: cobrada e nenhuma outra best seller de graca = o desconto nao esta valendo */
        if (p0 && p0.final_line_price > 0 && !TESTE && !bestGratis(cart, p0)) {
          m.pulSel = p0.variant_id; m.pulTrav = sig; gravar(m); denovo = true;
          return mudar(p0.key, 0).then(function () { return true; });
        }
      }

      for (i = 0; i < CFG.degraus.length; i++) {
        d = CFG.degraus[i];
        linhas = linhasDe(cart, d.n);
        l = linhas[0];
        var opL = l ? opcaoDe(d, l.product_id) : null;

        /* 1. caiu de degrau: o presente sai e fica guardado (escolha e tamanho) para voltar */
        if (l && v < d.min) {
          m.posto[d.n] = false;
          m.perdido[d.n] = true;
          if (d.escolha) m.esc[d.n] = l.product_id;
          if (opL && !opL.unica) m.tam[d.n] = l.variant_id;
          gravar(m); denovo = true;
          return mudar(l.key, 0).then(function () { return true; });
        }
        /* 2. em dobro: volta para 1 */
        if (linhas.length > 1) { denovo = true; return mudar(linhas[1].key, 0).then(function () { return true; }); }
        if (l && l.quantity > 1) { denovo = true; return mudar(l.key, 1).then(function () { return true; }); }

        /* 2b. presente a escolha: a cliente trocou de presente -> sai o antigo (o novo entra na volta
           seguinte). Presente no carrinho sem escolha guardada (outro aparelho): adota o do carrinho */
        if (l && d.escolha) {
          if (!m.esc[d.n]) { m.esc[d.n] = l.product_id; gravar(m); }
          else if (String(m.esc[d.n]) !== String(l.product_id)) {
            m.posto[d.n] = false; gravar(m); denovo = true;
            return mudar(l.key, 0).then(function () { return true; });
          }
        }

        /* 3. TRAVA: presente cobrado sai (fora do modo de teste). A cliente nao escolheu pagar por ele. */
        if (l && l.final_line_price > 0 && !TESTE) {
          m.posto[d.n] = false;
          m.travado[d.n] = sig;
          gravar(m); denovo = true;
          return mudar(l.key, 0).then(function () { return true; });
        }
        if (l) {
          if (!m.posto[d.n] || m.perdido[d.n]) { m.posto[d.n] = true; m.perdido[d.n] = false; gravar(m); }
          continue;
        }

        /* 4. degrau liberado e sem presente */
        if (v < d.min) continue;
        if (m.posto[d.n]) {                                        /* a cliente tirou */
          m.posto[d.n] = false;
          /* escada: nao volta mais. Escolha: volta para a escolha (nada entra sozinho) */
          if (d.escolha) { delete m.esc[d.n]; delete m.tam[d.n]; } else m.recusado[d.n] = true;
          gravar(m);
        }
        if (m.recusado[d.n]) continue;
        if (m.travado[d.n] === sig) continue;
        if (esgotado(m, d)) continue;

        var op = escolhida(m, d);
        if (!op) continue;                                         /* espera a escolha */
        var vid = op.unica ? op.variantes[0].id : m.tam[d.n];
        if (!vid) continue;                                        /* espera o tamanho */
        var vv = op.variantes.filter(function (x) { return x.id === vid; })[0];
        if (!vv || !vv.disp) { delete m.tam[d.n]; gravar(m); continue; }

        var props = {}; props[MARCA] = String(d.n);
        return (function (d, op, vv) {
          return pedir('/cart/add.js', { items: [{ id: vv.id, quantity: 1, properties: props }] }).then(function () {
            m.posto[d.n] = true; m.perdido[d.n] = false; gravar(m);
            denovo = true;
            return true;
          }, function (e) {
            if (e && e.status === 422) {                           /* sem estoque */
              vv.disp = false;
              if (op.unica) m.esgotado['p' + op.produto] = Date.now(); else delete m.tam[d.n];
              if (d.escolha && !opDisp(m, op)) delete m.esc[d.n];  /* volta para a escolha sem ele */
              gravar(m);
              denovo = true;                                       /* redesenha sem esse presente */
            }
            return false;
          });
        })(d, op, vv);
      }

      gravar(m);
      ultimo = { cart: cart, m: m };
      pkOcupado = false;
      desenhar();
      return false;
    });
  }

  /* ---------- fila: uma conferencia por vez ---------- */
  var rodando = false, timer = null, fila = [];
  function ocupado() { return rodando || timer !== null; }
  function agendar() {
    if (timer !== null) clearTimeout(timer);
    timer = setTimeout(girar, 80);
  }
  function girar() {
    timer = null;
    if (rodando) { denovo = true; return; }
    rodando = true;
    var voltas = 0, mexeu = false;
    function fim() {
      rodando = false;
      if (mexeu) redesenhar();
      else { try { window.sessionStorage.removeItem(CHAVE + '-r'); } catch (e) {} }
      var f = fila; fila = [];
      f.forEach(function (fn) { try { fn(); } catch (e) {} });
    }
    (function volta() {
      voltas++;
      denovo = false;
      conferirCarrinho().then(function (mx) {
        if (mx) mexeu = true;
        if (denovo && voltas < 10) volta(); else fim();
      }, fim);
    })();
  }

  /* ---------- pedir ao tema que redesenhe ---------- */
  var meu = false;
  function redesenhar() {
    if (window.theme && window.theme.settings && window.theme.settings.isCartTemplate) {
      try {
        var k = Number(window.sessionStorage.getItem(CHAVE + '-r') || 0);
        if (k >= 3) return;
        window.sessionStorage.setItem(CHAVE + '-r', String(k + 1));
      } catch (e) {}
      window.location.reload();
      return;
    }
    pedir('/cart.js').then(function (cart) {
      try {
        window.theme.pubsub.publish(window.theme.pubsub.PUB_SUB_EVENTS.cartUpdate, { source: 'sc-bf', cart: cart });
      } catch (e) {}
      meu = true;
      try { document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { open: false } })); } catch (e) {}
      meu = false;
    }, function () {});
  }

  /* ---------- desenho ---------- */
  function brl(c) {
    var x = Math.max(0, c) / 100;
    return 'R$ ' + x.toLocaleString('pt-BR', { minimumFractionDigits: c % 100 ? 2 : 0, maximumFractionDigits: 2 });
  }
  function esc(s) {
    return String(s).replace(/[&<>"]/g, function (ch) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[ch]; });
  }
  function estadoDe(d, cart, m, v) {
    if (linhasDe(cart, d.n).length) return 'claimed';
    if (v < d.min) return m.perdido[d.n] ? 'lost' : 'locked';
    if (!d.escolha && m.recusado[d.n]) return 'declined';
    var o = escolhida(m, d);
    if (!o) return 'choose';                                       /* presente a escolha: falta escolher */
    if (!o.unica && !m.tam[d.n]) return 'open';
    return 'wait';
  }
  /* trava o checkout: so na escada (presente com tamanho entrando sozinho). No presente a
     escolha o checkout fica livre, igual a Parla: so aparece o aviso (aEscolher) */
  function pendente(cart, m, v, lista) {
    for (var i = 0; i < lista.length; i++) if (!lista[i].escolha && estadoDe(lista[i], cart, m, v) === 'open') return lista[i];
    return null;
  }
  function aEscolher(cart, m, v, lista) {
    for (var i = 0; i < lista.length; i++) {
      var s = lista[i].escolha ? estadoDe(lista[i], cart, m, v) : '';
      if (s === 'choose' || s === 'open') return { d: lista[i], s: s };
    }
    return null;
  }

  var CADEADO = '<svg viewBox="0 0 10 10" fill="none" stroke="currentColor" stroke-width="1.2" aria-hidden="true"><rect x="2" y="4.5" width="6" height="4" rx="1"/><path d="M3.5 4.5V3a1.5 1.5 0 0 1 3 0v1.5"/></svg>';

  /* ---------- vaga da pulseira gratis (ultima linha da lista de itens) ---------- */
  var pk = null, pkOcupado = false, pkErro = '';
  function corDisp(c) { return c.vars.some(function (v) { return v.disp; }); }
  function modelosDisp() {
    var r = [];
    PUL.modelos.forEach(function (md, i) { if (md.cores.some(corDisp)) r.push(i); });
    return r;
  }
  function primeiroDisp(lista, igual) {
    for (var i = 0; i < lista.length; i++) if (igual(lista[i])) return i;
    return -1;
  }
  /* no modelo mi: a cor e o metal parecidos com os pedidos, se tiver; senao o primeiro disponivel */
  function parecida(mi, corNome, metal) {
    var md = PUL.modelos[mi];
    var ci = primeiroDisp(md.cores, function (c) { return c.cor === corNome && corDisp(c); });
    /* sem cor pedida (ou sem ela neste modelo): abre na cor inicial do editor (padrao: vermelho) */
    if (ci < 0 && PUL.cor) ci = primeiroDisp(md.cores, function (c) { return corDisp(c) && String(c.cor).toLowerCase().indexOf(PUL.cor) >= 0; });
    if (ci < 0) ci = primeiroDisp(md.cores, corDisp);
    var c = md.cores[ci];
    var vi = primeiroDisp(c.vars, function (v) { return v.metal === metal && v.disp; });
    if (vi < 0) vi = primeiroDisp(c.vars, function (v) { return v.disp; });
    return { m: mi, c: ci, v: vi };
  }
  function pkVar(x) { return PUL.modelos[x.m].cores[x.c].vars[x.v]; }
  function pkGarantir(m) {
    if (pk && pkVar(pk) && pkVar(pk).disp) return;
    pk = null;
    if (m.pulSel) {
      PUL.modelos.forEach(function (md, mi) {
        md.cores.forEach(function (c, ci) {
          c.vars.forEach(function (v, vi) { if (!pk && v.id === m.pulSel && v.disp) pk = { m: mi, c: ci, v: vi }; });
        });
      });
    }
    if (!pk) pk = parecida(modelosDisp()[0], null, null);
  }
  function nomesModelos(lista) {
    var n = lista.map(function (mi) { return PUL.modelos[mi].nome; });
    return n.length > 1 ? n.slice(0, -1).join(', ') + ' ou ' + n[n.length - 1] : n[0];
  }

  /* circulos "peca 1 + peca 2 = presente" da vaga: foto da peca paga ou "+" vazio (igual a barra do rodape) */
  function contaVaga(cart, np, cls) {
    var fotos = fotosPagas(cart);
    function circ(i) {
      if (i >= np) return '<span class="' + cls + '__c">+</span>';
      var f = fotoMini(fotos[i]);
      return '<span class="' + cls + '__c on">' + (f ? '<img src="' + esc(f) + '" alt="" loading="lazy">' : '') + '</span>';
    }
    return '<span class="' + cls + '__eq" aria-hidden="true">' + circ(0) + '<span class="' + cls + '__op">+</span>' + circ(1) +
      '<span class="' + cls + '__op">=</span><span class="' + cls + '__g">' + SVG_PRESENTE + '</span></span>';
  }
  /* opcao A (tema do mes). Cada foto leva para a pagina daquela pulseira, na cor e no metal da
     foto (pedido do Bruno, 27/10); o botao leva para o link do setting (todos os produtos).
     As fotos sao <button data-bf-url>, NAO <a href="/products/...">: o sc_crosssell_global trata
     todo <li> da gaveta com link de produto como item do carrinho e poe nele o X "Tirar uma
     unidade" (achado 29/10). Sem link de produto, a vaga fica fora dele. */
  function htmlVagaCard(cart, np, dispM) {
    var link = PUL.link || '/collections/all';
    var ps = dispM.map(function (mi) {
      var x = parecida(mi, null, null), c = PUL.modelos[mi].cores[x.c], v = pkVar(x), nm = PUL.modelos[mi].nome;
      var href = c.url ? c.url + (c.url.indexOf('?') >= 0 ? '&' : '?') + 'variant=' + v.id : link;
      return '<button type="button" class="sc-bf-va__p" data-bf-url="' + esc(href) + '" aria-label="Ver a ' + esc(nm) + '">' +
        '<span class="sc-bf-va__ph">' + (v.img ? '<img src="' + esc(v.img) + '" alt="" loading="lazy">' : '') + '</span>' +
        '<b>' + esc(nm) + '</b><span><s>' + brl(v.preco) + '</s><em>grátis</em></span></button>';
    }).join('');
    return '<div class="sc-bf-va"><span class="sc-bf-va__eye"><i>●</i> Black Friday · 3ª peça grátis</span>' +
      '<div class="sc-bf-va__row">' + contaVaga(cart, np, 'sc-bf-va') +
      '<span class="sc-bf-va__tx"><b>' + (np === 1 ? 'Falta 1 peça' : 'Leve 2 peças') + '</b><span>e a 3ª é uma pulseira grátis</span></span></div>' +
      '<div class="sc-bf-va__grid" style="--n:' + dispM.length + '">' + ps + '</div>' +
      '<a class="sc-bf-va__cta" href="' + esc(link) + '">' + (np === 1 ? 'Escolher a 2ª peça' : 'Ver as peças') + '</a></div>';
  }
  /* opcao D (tema da live): a barra do rodape dentro da gaveta, toda clicavel */
  function htmlVagaBarra(cart, np) {
    return '<a class="sc-bf-vd" href="' + esc(PUL.link || '/collections/all') + '">' + contaVaga(cart, np, 'sc-bf-vd') +
      '<span class="sc-bf-vd__tx"><b>' + (np === 1 ? 'Falta 1 peça para a 3ª grátis' : 'Leve 2 peças, a 3ª é grátis') + '</b>' +
      '<span>Pulseira de até ' + brl(maxGratis()) + ' por nossa conta</span></span>' +
      '<span class="sc-bf-vd__seta">' + SVG_SETA + '</span></a>';
  }

  function htmlVaga(cart, m) {
    if (!PUL) return '';
    var dispM = modelosDisp();
    if (!dispM.length) return '';
    if (linhasPul(cart).length || bestGratis(cart, null)) return '';   /* ja tem a gratis: a linha dela mostra */
    var np = pecasPagas(cart);
    if (np < 2) {
      /* convite antes de 2 pecas (pedido do Bruno, 29/10; mockup claude.ai/artifact/L1Y4yeSGj6pyt6ErZSoagv):
         tema do mes = card preto com a conta "peca + peca = presente", as pulseiras com preco riscado
         e o botao (opcao A); tema da live = a barra preta do rodape numa linha, porque o card do
         presente ja ocupa o topo da gaveta (opcao D) */
      return LIVE ? htmlVagaBarra(cart, np) : htmlVagaCard(cart, np, dispM);
    }
    if (m.pulTrav && m.pulTrav === assinatura(cart)) {
      return '<div class="sc-bf-vg"><span class="sc-bf-vg__th" aria-hidden="true">!</span><span class="sc-bf-vg__tx">' +
        '<b>3ª peça grátis</b><span>A pulseira grátis não está valendo neste carrinho.</span></span></div>';
    }

    pkGarantir(m);
    var md = PUL.modelos[pk.m], c = md.cores[pk.c], v = c.vars[pk.v];
    var h = '<div class="sc-bf-pk"><div class="sc-bf-pk__h"><b>Sua 3ª peça é grátis. Escolha a pulseira:</b>' +
      '<span>Você já tem 2 peças no carrinho. A 3ª é por nossa conta.</span></div>';
    h += '<div class="sc-bf-pk__m" style="--n:' + dispM.length + '">';
    dispM.forEach(function (mi) {
      var x = PUL.modelos[mi], vx = pkVar(parecida(mi, c.cor, v.metal));
      h += '<button type="button" class="sc-bf-pk__mb" data-bf-pm="' + mi + '" aria-pressed="' + (mi === pk.m) + '">' +
        '<span class="sc-bf-pk__ph">' + (vx.img ? '<img src="' + esc(vx.img) + '" alt="' + esc(x.nome) + '" loading="lazy">' : '') + '</span>' +
        '<span class="nm">' + esc(x.nome) + '</span><span class="pr"><s>' + brl(vx.preco) + '</s> <b>grátis</b></span></button>';
    });
    h += '</div><div class="sc-bf-pk__row"><span>Cor</span>';
    md.cores.forEach(function (cx, ci) {
      if (!corDisp(cx)) return;
      h += '<button type="button" class="sc-bf-pk__sw" data-bf-pc="' + ci + '" aria-pressed="' + (ci === pk.c) + '" aria-label="' + esc(cx.cor) +
        '" title="' + esc(cx.cor) + '" style="background:' + esc(cx.hex || '#c9c4ba') + '"></button>';
    });
    h += '<em>' + esc(c.cor) + '</em></div>';
    if (c.vars.length > 1 || c.vars[0].metal !== 'Default Title') {
      h += '<div class="sc-bf-pk__row"><span>Metal</span>';
      c.vars.forEach(function (vx, vi) {
        var pouco = vx.disp && vx.q > 0 && vx.q <= 3 ? ' <small>' + (vx.q === 1 ? 'Última unidade' : 'Últimas') + '</small>' : '';
        h += '<button type="button" class="sc-bf-pk__mt" data-bf-pv="' + vi + '" aria-pressed="' + (vi === pk.v) + '"' + (vx.disp ? '' : ' disabled') + '>' +
          (vx.hex ? '<i style="background:' + esc(vx.hex) + '"></i>' : '') + esc(vx.metal) + pouco + '</button>';
      });
      h += '</div>';
    }
    if (pkErro) h += '<span class="sc-bf-pk__erro">' + esc(pkErro) + '</span>';
    h += '<button type="button" class="sc-bf-pk__add" data-bf-padd' + (pkOcupado ? ' disabled' : '') + '>' +
      (pkOcupado ? 'Adicionando...' : 'Adicionar ' + esc(md.nome) + ' grátis') + '</button></div>';
    return h;
  }

  function htmlDoCard(cart, m) {
    var lista = ativos(cart, m);
    var de = lista.filter(function (d) { return d.escolha; })[0];
    var presentes = de ? htmlEscolha(cart, m, de) : htmlPresentes(cart, m);
    if (!presentes) return '';
    /* a faixa vermelha do modo de teste saiu do card (pedido do Bruno, 22/10); o aviso fica
       so no console. Desligar o modo de teste esta no checklist da virada. */
    return '<span class="sc-bf__eye">' + (LIVE ? '<i>●</i> Ao vivo · ' : 'Black Friday · ') + (de ? 'presente' : 'presentes') + '</span>' + presentes;
  }

  function oNomeOp(o) {
    var nm = String(o.nome || '');
    return (o.artigo || 'a') + ' ' + nm.charAt(0).toLowerCase() + nm.slice(1);
  }
  /* "a camiseta" na escada; "a camiseta ou a garrafa" no presente a escolha */
  function oNome(d) {
    if (d.opcoes && d.opcoes.length) return opsVis(d).map(oNomeOp).join(' ou ');
    return oNomeOp(d);
  }
  function maiuscula(t) { return t.charAt(0).toUpperCase() + t.slice(1); }

  function htmlPresentes(cart, m) {
    var v = valorPago(cart);
    var lista = ativos(cart, m);
    if (!lista.length) return '';
    var sts = lista.map(function (d) { return estadoDe(d, cart, m, v); });
    var liberados = lista.filter(function (d) { return v >= d.min; }).length;
    var prox = lista.filter(function (d) { return v < d.min; })[0];
    var perdido = lista.filter(function (d, i) { return sts[i] === 'lost'; })[0];
    var pend = pendente(cart, m, v, lista);
    var T;

    if (pend) T = 'Você ganhou ' + oNome(pend) + '. Escolha o tamanho';
    else if (perdido) T = maiuscula(oNome(perdido)) + ' saiu do carrinho. Faltam ' + brl(perdido.meta - v) + ' para recuperar';
    else if (!liberados) T = 'Faltam ' + brl(prox.meta - v) + ' para ganhar ' + oNome(prox);
    else if (prox) T = 'Faltam ' + brl(prox.meta - v) + ' para ganhar também ' + oNome(prox);
    else T = lista.length === 1 ? 'Você ganhou o presente' : 'Você ganhou os ' + lista.length + ' presentes';

    var h = '<div class="sc-bf__h">' + esc(T) + '</div>';

    /* barra em trechos (opcao B, validada 22/10): um trecho por presente, do degrau anterior
       ate o dele, com a foto do presente no fim. Embaixo, nome, valor e quanto falta. */
    var bar = '', lb = '', ant = 0;
    lista.forEach(function (d) {
      var ok = v >= d.min;
      var p = Math.max(0, Math.min(100, (v - ant) / Math.max(1, d.min - ant) * 100));
      bar += '<span class="sc-bf-rb__seg' + (ok ? ' ok' : '') + '"><i style="width:' + p.toFixed(1) + '%"></i></span>' +
        '<span class="sc-bf-rb__ic' + (ok ? ' ok' : '') + '">' + (d.img ? '<img src="' + esc(d.img) + '" alt="" loading="lazy">' : '') + '</span>';
      lb += '<span><b>' + esc(d.nome) + ' · ' + brl(d.meta) + '</b>' +
        (ok ? '<em class="ok">' + (d.artigo === 'o' ? 'Liberado' : 'Liberada') + '</em>' : '<em>Faltam ' + brl(d.meta - v) + '</em>') + '</span>';
      ant = d.min;
    });
    h += '<div class="sc-bf-rb" style="grid-template-columns:repeat(' + lista.length + ',minmax(0,1fr) auto)">' + bar + '</div>' +
      '<div class="sc-bf-rl" style="--n:' + lista.length + '">' + lb + '</div>';

    h += '<div class="sc-bf__g" style="--n:' + lista.length + '">';
    lista.forEach(function (d, i) {
      var s = sts[i];
      var linha = linhasDe(cart, d.n)[0];
      var selo = s === 'claimed' ? '<span class="sc-bf__selo ok">✓</span>'
        : (s === 'locked' || s === 'lost') ? '<span class="sc-bf__selo lock">' + CADEADO + '</span>' : '';
      var ctl;
      var opL = linha ? opcaoDe(d, linha.product_id) : null;
      if (s === 'claimed') ctl = '<span class="sc-bf__st ok">No carrinho' + (opL && !opL.unica && linha.variant_title ? ' · ' + esc(linha.variant_title) : '') + '</span>';
      else if (s === 'open') ctl = '<span class="sc-bf__st go">Escolha o tamanho</span>';
      else if (s === 'declined') ctl = '<button type="button" class="sc-bf__link" data-bf-quero="' + d.n + '">Adicionar ao carrinho</button>';
      else if (s === 'wait') ctl = '<span class="sc-bf__st">' + (m.travado[d.n] ? 'Indisponível neste carrinho' : 'Entrando no carrinho') + '</span>';
      else if (s === 'lost') ctl = '<span class="sc-bf__st">Saiu do carrinho</span>';
      else ctl = '';                                               /* travado: quanto falta ja esta na barra */

      h += '<div class="sc-bf__t is-' + s + '">' +
        '<a class="sc-bf__ph" href="' + esc(d.url) + '" target="_blank" rel="noopener">' +
          (d.img ? '<img src="' + esc(d.img) + '" alt="' + esc(d.titulo || d.nome) + '" loading="lazy">' : '') + selo + '</a>' +
        '<span class="sc-bf__nm">' + esc(d.titulo || d.nome) + '</span><span class="sc-bf__pr"><s>' + brl(d.preco) + '</s></span>' +
        ctl + '</div>';
    });
    h += '</div>';

    if (pend) {
      h += '<div class="sc-bf__tam">' + htmlChips(pend, escolhida(m, pend)) +
        '<button type="button" class="sc-bf__nao" data-bf-nao="' + pend.n + '">Não quero este presente</button></div>';
    }
    return h;
  }

  function htmlChips(d, o) {
    var h = '<div class="sc-bf__chips">';
    o.variantes.forEach(function (x) {
      h += '<button type="button" class="sc-bf__chip" data-bf-tam="' + d.n + '" data-vid="' + x.id + '"' +
        (x.disp ? '' : ' disabled aria-label="' + esc(x.titulo) + ', esgotado"') + '><b>' + esc(x.titulo) + '</b>' +
        (x.disp ? '' : '<small>esgotado</small>') + '</button>';
    });
    return h + '</div>';
  }

  /* ---------- presente a escolha (26/10): R$ 999 pago = 1 presente, a cliente escolhe ----------
     Mesmo card escuro da escada, com a logica do card da Parla: travado com cadeado ate o valor;
     liberado, cada presente tem "Escolher" (a foto tambem escolhe); com tamanho, abre os
     tamanhos e o toque no tamanho poe no carrinho; no carrinho, o outro presente ganha "Trocar". */
  function htmlEscolha(cart, m, d) {
    var v = valorPago(cart);
    var s = estadoDe(d, cart, m, v);
    var linha = linhasDe(cart, d.n)[0];
    var opL = linha ? opcaoDe(d, linha.product_id) : null;
    var ops = opcoesDisp(m, d);
    if (opL && ops.indexOf(opL) < 0) ops = [opL].concat(ops);    /* a ultima unidade pode estar neste carrinho */
    if (!ops.length) return '';
    var esc0 = escolhida(m, d);
    var ok = v >= d.min;
    var umSo = ops.length === 1;
    var nomes = ops.map(oNomeOp).join(' ou ');
    var T;
    if (s === 'claimed') T = 'Você ganhou ' + oNomeOp(opL || ops[0]);
    else if (s === 'lost') T = 'Seu presente saiu do carrinho. Faltam ' + brl(d.meta - v) + ' para recuperar';
    else if (s === 'locked') T = 'Faltam ' + brl(d.meta - v) + ' para ganhar ' + nomes;
    else if (s === 'choose') T = umSo ? 'Você ganhou ' + nomes + ' de presente' : 'Você ganhou um presente. Escolha ' + nomes;
    else if (s === 'open') T = 'Escolha o tamanho d' + oNomeOp(esc0);
    else T = m.travado[d.n] ? 'O presente não está valendo neste carrinho' : 'Seu presente está entrando no carrinho';

    var h = '<div class="sc-bf__h">' + esc(T) + '</div>';
    var p = Math.max(0, Math.min(100, v / Math.max(1, d.min) * 100));
    h += '<div class="sc-bf-rb" style="grid-template-columns:minmax(0,1fr) auto">' +
      '<span class="sc-bf-rb__seg' + (ok ? ' ok' : '') + '"><i style="width:' + p.toFixed(1) + '%"></i></span>' +
      '<span class="sc-bf-rb__ic' + (ok ? ' ok' : '') + '">' + ((opL || ops[0]).img ? '<img src="' + esc((opL || ops[0]).img) + '" alt="" loading="lazy">' : '') + '</span></div>' +
      '<div class="sc-bf-rl" style="--n:1"><span><b>Presente · ' + brl(d.meta) + '</b>' +
      (ok ? '<em class="ok">Liberado</em>' : '<em>Faltam ' + brl(d.meta - v) + '</em>') + '</span></div>';

    h += '<div class="sc-bf__g" style="--n:' + ops.length + '">';
    ops.forEach(function (o) {
      var eEsta = !!(opL && opL === o);
      var escolheu = !!(esc0 && esc0 === o);
      var cls, selo = '', ctl, escolhe = false;
      if (s === 'locked' || s === 'lost') {
        cls = 'is-locked';
        selo = '<span class="sc-bf__selo lock">' + CADEADO + '</span>';
        ctl = '';
      } else if (s === 'claimed') {
        if (eEsta) {
          cls = 'is-claimed';
          selo = '<span class="sc-bf__selo ok">✓</span>';
          ctl = '<span class="sc-bf__st ok">No carrinho' + (!o.unica && linha.variant_title ? ' · ' + esc(linha.variant_title) : '') + '</span>';
        } else {
          cls = 'is-choose'; escolhe = true;
          ctl = '<button type="button" class="sc-bf__outro" data-bf-esc="' + d.n + '" data-pid="' + o.produto + '">Trocar pel' + esc(oNomeOp(o)) + '</button>';
        }
      } else if (escolheu && s === 'open') {
        cls = 'is-open';
        selo = '<span class="sc-bf__selo ok">✓</span>';
        ctl = '<span class="sc-bf__st go">Escolha o tamanho</span>';
      } else if (escolheu && s === 'wait') {
        cls = 'is-open';
        ctl = '<span class="sc-bf__st">' + (m.travado[d.n] ? 'Indisponível neste carrinho' : 'Entrando no carrinho') + '</span>';
      } else {
        cls = 'is-choose'; escolhe = true;
        ctl = '<button type="button" class="sc-bf__link" data-bf-esc="' + d.n + '" data-pid="' + o.produto + '">' + (!umSo ? 'Escolher' : o.unica ? 'Adicionar ao carrinho' : 'Escolher o tamanho') + '</button>';
      }
      var foto = (o.img ? '<img src="' + esc(o.img) + '" alt="' + esc(o.titulo || o.nome) + '" loading="lazy">' : '') + selo;
      h += '<div class="sc-bf__t ' + cls + '">' +
        (escolhe ? '<button type="button" class="sc-bf__ph" data-bf-esc="' + d.n + '" data-pid="' + o.produto + '" aria-label="Escolher ' + esc(o.nome) + '">' + foto + '</button>'
                 : '<a class="sc-bf__ph" href="' + esc(o.url) + '" target="_blank" rel="noopener">' + foto + '</a>') +
        '<span class="sc-bf__nm">' + esc(o.titulo || o.nome) + '</span><span class="sc-bf__pr"><s>' + brl(o.preco) + '</s><b>grátis</b></span>' +
        ctl + '</div>';
    });
    h += '</div>';

    if (s === 'open' && esc0) h += '<div class="sc-bf__tam">' + htmlChips(d, esc0) + '</div>';
    return h;
  }

  var pendAtual = null, sigCard = '';

  function lugar() {
    var ci = document.querySelector('cart-drawer cart-items');
    if (!ci) return null;
    var sc = ci.closest('.drawer__scrollable');
    if (!sc || sc.classList.contains('hidden')) return null;
    return sc;
  }

  function desenhar() {
    var sc = lugar();
    var temItens = !!(sc && ultimo && (ultimo.cart.items || []).length);
    desenharCard(sc, temItens);
    desenharVaga(temItens);
    if (temItens) marcarLinhas();
    desenharPdp();
    desenharBarra();
  }

  /* vaga: ultima linha da lista de itens da gaveta. O tema troca a lista a cada
     cart:refresh; o observador da partida recoloca a vaga no mesmo quadro. */
  var sigVaga = '';
  function desenharVaga(temItens) {
    var el = document.querySelector('[data-sc-bf-vaga]');
    var lista = document.querySelector('cart-drawer cart-items ul.horizontal-products') || document.querySelector('cart-drawer cart-items ul');
    var html = (temItens && lista) ? htmlVaga(ultimo.cart, ultimo.m) : '';
    if (!html) { if (el) el.remove(); sigVaga = ''; return; }
    if (!el) {
      el = document.createElement('li');
      el.className = 'sc-bf-vaga';
      el.setAttribute('data-sc-bf-vaga', '');
      sigVaga = '';
    }
    if (html !== sigVaga) { el.innerHTML = html; sigVaga = html; }
    if (el.parentNode !== lista || lista.lastElementChild !== el) lista.appendChild(el);
    /* veio do "Levar as duas" da PDP: leva a cliente direto para a escolha da gratis */
    if (irVaga && Date.now() - irVaga < 8000 && el.querySelector('.sc-bf-pk')) {
      irVaga = 0;
      try { el.scrollIntoView({ block: 'center', behavior: 'smooth' }); } catch (e) {}
    }
  }

  /* etiquetas nas linhas: presentes e pulseira gratis (com o "Trocar") */
  function etiqueta(li, txt) {
    if (li.querySelector('.sc-bf-tag')) return;
    var det = li.querySelector('.horizontal-product__details') || li;
    var tag = document.createElement('span');
    tag.className = 'sc-bf-tag';
    tag.textContent = txt;
    det.insertBefore(tag, det.firstChild);
  }
  function marcarLinhas() {
    var cart = ultimo.cart;
    var p0 = PUL ? linhasPul(cart)[0] : null;
    var gratis = null;
    if (PUL) {
      /* a marcada e a gratis, a nao ser que a Shopify tenha dado outra best seller e cobrado ela */
      gratis = p0 && !(p0.final_line_price > 0 && bestGratis(cart, p0)) ? p0 : bestGratis(cart, null);
    }
    (cart.items || []).forEach(function (it) {
      var li = document.getElementById('CartDrawer-Item-' + it.key);
      if (!li) return;
      if (degrauDe(it)) etiqueta(li, 'Presente Black Friday');
      else if (it === gratis) etiqueta(li, 'Presente Black Friday');
      if (it === p0 && !li.querySelector('[data-bf-ptroca]')) {
        var det = li.querySelector('.horizontal-product__details') || li;
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'sc-bf-troca';
        b.setAttribute('data-bf-ptroca', it.key);
        b.setAttribute('data-vid', it.variant_id);
        b.textContent = 'Trocar modelo ou cor';
        det.appendChild(b);
      }
    });
  }

  /* ---------- card da Black na PDP (snippets/sc-col-extra, [data-scbfc]) ----------
     Refeito em 31/10 (opcao C validada pelo Bruno, mockup claude.ai/artifact/NV3xYuAzgAgrzp9P27bF3W):
     - regua "2 pecas = a 3a gratis" contando as pecas pagas do carrinho. A parte listrada e o
       que esta peca soma se a cliente comprar (+1 peca).
     - as pulseiras gratis com estoque, lado a lado, com "R$ 0" e o preco riscado.
     - tema da live: regua do presente por valor pago (camiseta ou garrafa acima de R$ 1.000),
       com esta peca somando o preco dela.
     - a linha "Combina com esta" (par, so quando o produto tem combina_com) aparece enquanto
       faltam pecas e o par nao esta no carrinho. O "+ Adicionar" dela e do proprio snippet.
     Textos do Bruno: "Levando 2 pecas, a 3a e por nossa conta" e "Levando esta, voce ganha a
     camiseta ou garrafa". Sem nada para mostrar (pulseiras esgotadas e fora da live), o card some. */
  var sigPdp = '', irVaga = 0;
  function maxGratis() {
    var mx = 0;
    PUL.modelos.forEach(function (md) { md.cores.forEach(function (c) { c.vars.forEach(function (v) { if (v.disp && v.preco > mx) mx = v.preco; }); }); });
    return mx;
  }
  var ICO_PRES = '<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="3.5" y="9" width="17" height="11" rx="1.5"/><path d="M2.5 9h19M12 9v11"/><path d="M12 9c-1.5-3.5-5.5-4.5-6-2s3 2 6 2zM12 9c1.5-3.5 5.5-4.5 6-2s-3 2-6 2z"/></svg>';
  var ICO_OK = '<svg viewBox="0 0 24 24" aria-hidden="true" style="stroke-width:2.6"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>';
  function pct(a, b) { return Math.max(0, Math.min(100, b > 0 ? a / b * 100 : 0)); }
  function reguaPdp(fill, ghost, cls, capE, capD) {
    return '<div><div class="scbfn__row"><div class="scbfn__bar' + (cls === 'ok' ? ' ok' : '') + '">' +
      '<i class="g" style="width:' + ghost.toFixed(1) + '%"></i><i class="f" style="width:' + fill.toFixed(1) + '%"></i></div>' +
      '<span class="scbfn__gi ' + cls + '">' + (cls === 'ok' ? ICO_OK : ICO_PRES) + '</span></div>' +
      '<div class="scbfn__cap"><span>' + capE + '</span>' + (capD || '') + '</div></div>';
  }
  function desenharPdp() {
    var box = document.querySelector('[data-scbfc]');
    if (!box || !ultimo) return;
    var cart = ultimo.cart, m = ultimo.m;
    var pid = String(box.getAttribute('data-pid') || '');
    var p1c = Number(box.getAttribute('data-p1c')) || 0;
    var fora = !!PRESENTE[pid];                   /* camiseta/garrafa: nao conta e nao mostra o card */
    var h = '', okP = false;

    if (PUL && !fora) {
      var n = pecasPagas(cart);
      var temGratis = !!(linhasPul(cart).length || bestGratis(cart, null));
      okP = n >= 2 || temGratis;
      var dispM = modelosDisp();
      var add = (PUL.todos || CONTA[pid]) ? 1 : 0;
      if (okP || dispM.length) {
        var hd, st, capD;
        if (okP) {
          hd = 'Sua 3ª peça já é grátis';
          st = temGratis ? 'A pulseira grátis já está no carrinho.' : 'Você escolhe a pulseira no carrinho.';
          capD = '<span class="k">3ª grátis garantida</span>';
        } else if (n + add >= 2) {
          hd = 'Levando esta, a sua 3ª peça sai grátis';
          st = 'Você já tem ' + n + ' peça no carrinho.';
          capD = '<span class="r">com esta: 3ª grátis</span>';
        } else {
          hd = 'Levando 2 peças, a 3ª é por nossa conta';
          st = n ? 'Você já tem ' + n + ' peça no carrinho.' : (add ? 'Esta conta como a 1ª. Falta mais 1 peça.' : '');
          capD = add ? '<span class="r">com esta: ' + (n + add) + ' de 2</span>' : '';
        }
        var cls = okP ? 'ok' : (n + add >= 2 ? 'vai' : '');
        h += '<p class="scbfn__tx">' + hd + (st ? '<small>' + st + '</small>' : '') + '</p>';
        h += reguaPdp(pct(Math.min(n, 2), 2), okP ? 0 : pct(Math.min(n + add, 2), 2), cls, (okP ? 2 : Math.min(n, 2)) + ' de 2 peças', capD);
        if (dispM.length) {
          h += '<div class="scbfn__trio">' + dispM.map(function (mi) {
            var v = pkVar(parecida(mi, null, null));
            var nome = PUL.modelos[mi].nome;
            return '<span>' + (v && v.img ? '<img src="' + esc(v.img) + '" alt="Pulseira ' + esc(nome) + '" loading="lazy">' : '') +
              esc(nome) + '<span><span class="scbfn__p0">R$ 0</span> <span class="scbfn__rs">' + brl(v ? v.preco : 0) + '</span></span></span>';
          }).join('') + '</div>';
        }
        if (okP) h += '<button type="button" class="scbfn__lk" data-scbf-gaveta' + (temGratis ? '' : ' data-ir') + '>' +
          (temGratis ? 'Ver no carrinho' : 'Escolher a pulseira no carrinho') + '</button>';
      }
    }

    /* tema da live: presente a escolha por valor pago */
    var d = LIVE && !fora ? ativos(cart, m)[0] : null;
    if (d) {
      var v0 = valorPago(cart), vCom = v0 + p1c;
      var okV = !!linhasDe(cart, d.n).length || v0 >= d.min, vai = !okV && vCom >= d.min;
      var nm = nomeD(d), low = nm.toLowerCase(), art = d.artigo || 'a';
      var txV = okV ? 'Presente liberado: ' + low :
        vai ? 'Levando esta, você ganha ' + art + ' ' + low :
        'Acima de ' + brl(d.meta) + ', você ' + (opsVis(d).length > 1 ? 'escolhe ' : 'ganha ' + art + ' ') + low + ' de presente';
      var capV = okV ? '<span class="k">liberado</span>' : vai ? '<span class="r">com esta: liberado</span>' :
        '<span class="r">com esta: faltam ' + brl(d.meta - vCom) + '</span>';
      if (h) h += '<div class="scbfn__sep"></div>';
      h += '<p class="scbfn__tx">' + esc(txV) + '</p>';
      h += reguaPdp(pct(v0, d.meta), okV ? 0 : pct(vCom, d.meta), okV ? 'ok' : (vai ? 'vai' : ''), brl(v0) + ' de ' + brl(d.meta), capV);
      var ops = opsVis(d);
      h += '<div class="scbfn__mini">' + ops.map(function (o) { return o.img ? '<img src="' + esc(o.img) + '" alt="' + esc(o.nome) + '" loading="lazy">' : ''; }).join('') +
        '<span>' + (ops.length > 1 ? esc(nm) + ', você escolhe 1' : esc(nm) + ' de presente') + '</span></div>';
    }

    /* linha do par: some com a 3a garantida, com o par no carrinho ou sem a regua */
    var sug = box.querySelector('[data-scbf-sug]'), escSug = true;
    if (sug && PUL && !fora && !okP) {
      var parId = String(sug.getAttribute('data-pid') || '');
      escSug = (cart.items || []).some(function (it) { return String(it.product_id) === parId && !ehPul(it); });
    }

    var sig = h + '|' + escSug;
    if (sig === sigPdp) return;
    sigPdp = sig;
    var corpo = box.querySelector('[data-scbf-corpo]');
    if (corpo) corpo.innerHTML = h;
    if (sug) sug.hidden = escSug || !h;
    box.classList.toggle('is-pronto', !!h);
  }

  /* card da PDP: "Escolher a pulseira no carrinho" abre a gaveta (com 2 pecas, rola ate o
     seletor); o "+ Adicionar" do par marca a hora para a gaveta rolar ate o seletor se fechar 2 */
  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest ? e.target : null;
    if (!t || !t.closest('[data-scbfc]')) return;
    var g = t.closest('[data-scbf-gaveta]');
    if (g) { e.preventDefault(); abrirGaveta(g.hasAttribute('data-ir')); return; }
    if (t.closest('[data-scbf-sug-add]')) irVaga = Date.now();
  }, true);

  function desenharCard(sc, temItens) {
    var card = document.querySelector('[data-sc-bf]');
    var aviso = document.querySelector('[data-sc-bf-aviso]');
    var html = temItens ? htmlDoCard(ultimo.cart, ultimo.m) : '';
    var soNota = false;
    if (!html && temItens && !LIVE && saiuLiveRecente()) {
      html = '<p class="sc-bf__nota">O presente da live saiu do carrinho: a live terminou.</p>';
      soNota = true;
    }

    if (!html) {
      if (card) card.remove();
      if (aviso) aviso.remove();
      pendAtual = null; sigCard = '';
      raiz.classList.remove('sc-bf-travado');
      return;
    }

    var v = valorPago(ultimo.cart);
    pendAtual = pendente(ultimo.cart, ultimo.m, v, ativos(ultimo.cart, ultimo.m));
    raiz.classList.toggle('sc-bf-travado', !!pendAtual);

    if (!card) {
      card = document.createElement('div');
      card.className = 'sc-bf';
      card.setAttribute('data-sc-bf', '');
      sigCard = '';
    }
    if (html !== sigCard) { card.innerHTML = html; sigCard = html; }
    card.classList.toggle('sc-bf--nota', soNota);

    /* no celular a regua de desconto e o primeiro filho; o card vem logo depois */
    var regua = null, f = sc.firstElementChild;
    if (f && f.hasAttribute('data-sc-esc')) regua = f;
    var depoisDe = regua ? regua.nextElementSibling : sc.firstElementChild;
    if (card.parentNode !== sc || depoisDe !== card) sc.insertBefore(card, regua ? regua.nextSibling : sc.firstChild);

    /* aviso acima do botao de checkout: escada = trava; presente a escolha = so aviso (igual a Parla) */
    var form = document.querySelector('cart-drawer .drawer__footer-buttons');
    var ae = pendAtual ? null : aEscolher(ultimo.cart, ultimo.m, v, ativos(ultimo.cart, ultimo.m));
    if ((pendAtual || ae) && form) {
      if (!aviso) {
        aviso = document.createElement('div');
        aviso.className = 'sc-bf-aviso';
        aviso.setAttribute('data-sc-bf-aviso', '');
      }
      var msg = pendAtual ? 'Falta escolher o tamanho d' + oNome(pendAtual) + '.'
        : ae.s === 'choose' ? 'Você ainda não escolheu seu presente.'
        : 'Falta escolher o tamanho d' + oNomeOp(escolhida(ultimo.m, ae.d)) + '.';
      var txt = '<span>' + esc(msg) + '</span><button type="button" data-bf-ir="">Escolher agora</button>';
      if (aviso.innerHTML !== txt) aviso.innerHTML = txt;
      if (aviso.nextElementSibling !== form) form.parentNode.insertBefore(aviso, form);
    } else if (aviso) { aviso.remove(); }
  }

  function irParaOCard() {
    var card = document.querySelector('[data-sc-bf]');
    if (!card) return;
    card.classList.add('is-flash');
    setTimeout(function () { card.classList.remove('is-flash'); }, 1600);
    if (card.scrollIntoView) card.scrollIntoView({ block: 'center', behavior: 'smooth' });
  }

  /* ---------- cliques ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest ? e.target : null;
    if (!t) return;
    var b, m;

    /* convite da vaga (opcao A): foto da pulseira leva para a pagina dela */
    b = t.closest('[data-bf-url]');
    if (b) { window.location.href = b.getAttribute('data-bf-url'); return; }

    /* seletor da pulseira gratis */
    if (PUL && pk) {
      b = t.closest('[data-bf-pm]');
      if (b) { var vm = pkVar(pk); pk = parecida(Number(b.getAttribute('data-bf-pm')), PUL.modelos[pk.m].cores[pk.c].cor, vm.metal); pkErro = ''; desenhar(); return; }
      b = t.closest('[data-bf-pc]');
      if (b) { pk = parecida(pk.m, PUL.modelos[pk.m].cores[Number(b.getAttribute('data-bf-pc'))].cor, pkVar(pk).metal); pkErro = ''; desenhar(); return; }
      b = t.closest('[data-bf-pv]');
      if (b && !b.disabled) { pk = { m: pk.m, c: pk.c, v: Number(b.getAttribute('data-bf-pv')) }; pkErro = ''; desenhar(); return; }
      b = t.closest('[data-bf-padd]');
      if (b) {
        var v = pkVar(pk);
        if (pkOcupado || !v || !v.disp) return;
        pkOcupado = true; pkErro = ''; desenhar();
        var props = {}; props[MARCA_P] = '1';
        pedir('/cart/add.js', { items: [{ id: v.id, quantity: 1, properties: props }] }).then(function () {
          var mm = limpa(ler()); mm.pulSel = v.id; delete mm.pulTrav; gravar(mm);
          redesenhar(); agendar();                                   /* pkOcupado volta na proxima leitura */
        }, function (er) {
          pkOcupado = false;
          if (er && er.status === 422) { v.disp = false; pk = null; pkErro = 'Essa acabou de esgotar. Escolha outra cor ou metal.'; }
          else pkErro = 'Não deu para adicionar agora. Tente de novo.';
          desenhar();
        });
        return;
      }
    }
    b = t.closest('[data-bf-ptroca]');
    if (b) {
      if (b.disabled) return;
      b.disabled = true;
      m = limpa(ler()); m.pulSel = Number(b.getAttribute('data-vid')); delete m.pulTrav; gravar(m);
      if (ultimo) ultimo.m = m;
      pk = null;
      mudar(b.getAttribute('data-bf-ptroca'), 0).then(function () { redesenhar(); agendar(); }, function () { b.disabled = false; });
      return;
    }

    /* presente a escolha: escolher ou trocar (foto, "Escolher" ou "Trocar pela ...") */
    b = t.closest('[data-bf-esc]');
    if (b) {
      m = limpa(ler());
      var nEsc = b.getAttribute('data-bf-esc'), pid = Number(b.getAttribute('data-pid'));
      if (String(m.esc[nEsc]) !== String(pid)) delete m.tam[nEsc];   /* tamanho era do outro presente */
      m.esc[nEsc] = pid;
      delete m.travado[nEsc]; delete m.recusado[nEsc];
      gravar(m);
      if (ultimo) { ultimo.m = m; desenhar(); }
      agendar();
      return;
    }

    b = t.closest('[data-bf-tam]');
    if (b && !b.disabled) {
      m = limpa(ler());
      m.tam[b.getAttribute('data-bf-tam')] = Number(b.getAttribute('data-vid'));
      delete m.travado[b.getAttribute('data-bf-tam')];
      gravar(m);
      if (ultimo) { ultimo.m = m; desenhar(); }
      agendar();
      return;
    }
    b = t.closest('[data-bf-nao]');
    if (b) {
      m = limpa(ler());
      m.recusado[b.getAttribute('data-bf-nao')] = true;
      gravar(m);
      if (ultimo) { ultimo.m = m; desenhar(); }
      return;
    }
    b = t.closest('[data-bf-quero]');
    if (b) {
      m = limpa(ler());
      delete m.recusado[b.getAttribute('data-bf-quero')];
      delete m.travado[b.getAttribute('data-bf-quero')];
      delete m.tam[b.getAttribute('data-bf-quero')];             /* volta a perguntar o tamanho */
      gravar(m);
      if (ultimo) { ultimo.m = m; desenhar(); }
      agendar();
      return;
    }
    if (t.closest('[data-bf-ir]')) { irParaOCard(); return; }
  });

  /* checkout da gaveta: travado enquanto falta tamanho; espera a conferencia em andamento */
  document.addEventListener('click', function (e) {
    var alvo = e.target && e.target.closest ? e.target.closest('[name="checkout"], a[href$="/checkout"]') : null;
    if (!alvo || !alvo.closest('cart-drawer')) return;

    if (pendAtual) {
      e.preventDefault();
      e.stopImmediatePropagation();
      irParaOCard();
      return;
    }
    if (alvo.getAttribute('data-sc-bf-ok') || !ocupado()) return;

    e.preventDefault();
    e.stopImmediatePropagation();
    var solto = false;
    function soltar() {
      if (solto) return;
      solto = true;
      if (pendAtual) { irParaOCard(); return; }
      var btn = document.contains(alvo) ? alvo : document.querySelector('cart-drawer [name="checkout"]');
      if (!btn) return;
      btn.setAttribute('data-sc-bf-ok', '1');
      setTimeout(function () { btn.removeAttribute('data-sc-bf-ok'); }, 4000);
      btn.click();
    }
    fila.push(soltar);
    setTimeout(soltar, 2500);
  }, true);

  /* ---------- barra "compre 2, leve 3" no rodape (pedido do Bruno, 26/10) ----------
     "peca 1 + peca 2 = presente" fixa no rodape, para a cliente ver a promocao sem abrir o
     carrinho. Fora da PDP e do /cart (CFG.barra vem false do Liquid nessas paginas: na PDP
     ja tem o card da Black e a barra de compra fixa). Le o mesmo carrinho da gaveta, entao
     nunca promete o que o carrinho nao da: sem best seller disponivel (todas esgotadas) ou
     com a gratis travada, a barra some.
     Estados: 0 e 1 peca (convite), 2 pecas (liberada: toque abre a gaveta na escolha),
     gratis no carrinho (foto da pulseira + quanto falta para o proximo presente).
     Some com qualquer gaveta aberta. Com a barra no ar, WhatsApp, "Recompensas" (Smile) e o
     botao de filtro das colecoes sobem (CSS no Liquid, via --scbf-bar). */
  var BARRA = !!(PUL && CFG.barra);
  var barEl = null, sigBar = '', nAntes = -1;
  var mqCel = window.matchMedia ? window.matchMedia('(max-width: 999px)') : null;
  /* presente solido, no estilo do botao de app (pedido do Bruno, 26/10) */
  var SVG_PRESENTE = '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><rect x="3" y="7" width="8" height="3.4" rx="1"/><rect x="13" y="7" width="8" height="3.4" rx="1"/><rect x="4" y="11.6" width="7" height="9" rx="1"/><rect x="13" y="11.6" width="7" height="9" rx="1"/><path d="M12 6.6C10.2 6.6 7.6 6.4 7.1 5 6.7 3.8 7.8 2.7 9 3.1 10.4 3.6 11.4 5.2 12 6.6ZM12 6.6C13.8 6.6 16.4 6.4 16.9 5 17.3 3.8 16.2 2.7 15 3.1 13.6 3.6 12.6 5.2 12 6.6Z"/></svg>';
  var SVG_SETA = '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 3l5 5-5 5"/></svg>';

  function fotoMini(u) { return u ? u + (u.indexOf('?') >= 0 ? '&' : '?') + 'width=120' : ''; }
  /* fotos das 2 primeiras pecas pagas, da mais antiga para a mais nova (o /cart.js lista a
     mais nova primeiro): a peca que acabou de entrar enche o circulo da direita. A mesma peca
     com quantidade 2 enche os dois circulos */
  function fotosPagas(cart) {
    var r = [];
    (cart.items || []).slice().reverse().forEach(function (it) {
      if (ehPul(it) || foraDaConta(it) || it.gift_card) return;
      if (!PUL.todos && !CONTA[String(it.product_id)]) return;
      for (var i = 0; i < (it.quantity || 1) && r.length < 2; i++) r.push(it.image || '');
    });
    return r;
  }
  function gavetaAberta() { return !!document.querySelector('.drawer[open], [role="dialog"][open], .modal[open]'); }

  function estadoBarra(cart, m) {
    var p0 = linhasPul(cart)[0];
    /* a gratis de verdade: a marcada, a nao ser que a Shopify tenha dado outra best seller (igual a marcarLinhas) */
    var gr = p0 && !(p0.final_line_price > 0 && bestGratis(cart, p0)) ? p0 : bestGratis(cart, null);
    if (gr) return { n: 3, gr: gr };
    var dispM = modelosDisp();
    if (!dispM.length) return null;                                  /* nada para dar: some */
    var np = pecasPagas(cart);
    if (np >= 2 && m.pulTrav && m.pulTrav === assinatura(cart)) return null;   /* gratis nao vale neste carrinho */
    return { n: Math.min(np, 2), dispM: dispM };
  }

  /* textos: no celular mais curtos, para caber numa linha ao lado dos circulos */
  function textosBarra(e, cart, m, cel) {
    /* nomes das pulseiras da promocao (sem as esgotadas), para ninguem achar que a 3a e qualquer peca da loja (pedido do Bruno, 26/10) */
    if (e.n === 0) return cel ? ['Leve 2, a 3ª é grátis', nomesModelos(e.dispM)]
      : ['Leve 2 peças, a 3ª é grátis', nomesModelos(e.dispM) + ' por nossa conta'];
    if (e.n === 1) return cel ? ['Falta 1 peça', 'para ganhar a 3ª grátis']
      : ['Falta 1 peça para a 3ª grátis', PUL.todos ? 'Qualquer peça do site vale' : 'Escolha mais uma peça'];
    if (e.n === 2) return cel ? ['3ª peça liberada 🎁', 'Toque para escolher a sua']
      : ['Você ganhou a 3ª peça 🎁', 'Escolha a sua pulseira no carrinho'];
    var v = valorPago(cart), prox = ativos(cart, m).filter(function (d) { return v < d.min; })[0];
    var s;
    /* no celular o valor vai em reais inteiros, arredondado para cima (centavos cortavam o texto) */
    /* celular: "Faltam R$ X p/ presente"; se nao couber (Android de 360px), desenharBarra troca pela
       versao curta "Mais R$ X = presente" (data-curto) */
    var curto = '';
    if (prox && cel) {
      var fv = brl(Math.ceil((prox.meta - v) / 100) * 100), oq = opsVis(prox).length > 1 ? 'presente' : nomeD(prox).toLowerCase();
      s = 'Faltam ' + fv + ' p/ ' + oq; curto = 'Mais ' + fv + ' = ' + oq;
    } else if (prox) s = 'Faltam ' + brl(prox.meta - v) + ' para ganhar ' + oNome(prox);
    else s = cel ? 'É só finalizar a compra' : 'Tudo certo, é só finalizar a compra';
    return [cel ? '3ª peça garantida' : '3ª peça grátis no carrinho', s, curto];
  }

  function htmlBarra(e, cart, m, cel) {
    var t = textosBarra(e, cart, m, cel);
    var fotos = fotosPagas(cart);
    function circ(i) {
      var on = e.n > i || (e.n === 3 && fotos[i] !== undefined);
      if (!on) return '<span class="sc-bf-bar__c" data-i="' + i + '">+</span>';
      var f = fotoMini(fotos[i]);
      return '<span class="sc-bf-bar__c on" data-i="' + i + '">' + (f ? '<img src="' + esc(f) + '" alt="" loading="lazy">' : '') + '</span>';
    }
    var g;
    if (e.n === 3) {
      var gf = fotoMini(e.gr.image || '');
      g = '<span class="sc-bf-bar__c sc-bf-bar__g got">' + (gf ? '<img src="' + esc(gf) + '" alt="" loading="lazy">' : SVG_PRESENTE) + '<i>✓</i></span>';
    } else {
      g = '<span class="sc-bf-bar__c sc-bf-bar__g' + (e.n === 2 ? ' ok' : '') + '">' + SVG_PRESENTE + '</span>';
    }
    var ok = e.n >= 2;
    var fim = '';
    if (cel) { if (e.n > 0) fim = '<span class="sc-bf-bar__seta' + (e.n === 2 ? ' forte' : '') + '">' + SVG_SETA + '</span>'; }
    else if (e.n === 2) fim = '<span class="sc-bf-bar__go">Escolher</span>';
    else if (e.n === 3) fim = '<span class="sc-bf-bar__go fino">Ver carrinho</span>';
    return '<span class="sc-bf-bar__sl" aria-hidden="true">' + circ(0) + '<span class="sc-bf-bar__op">+</span>' + circ(1) +
      '<span class="sc-bf-bar__op' + (ok ? ' ok' : '') + '">=</span>' + g + '</span>' +
      '<span class="sc-bf-bar__tx" aria-live="polite"><b>' + esc(t[0]) + '</b><span' + (e.n === 2 ? ' class="ok"' : '') + (t[2] ? ' data-curto="' + esc(t[2]) + '"' : '') + '>' + esc(t[1]) + '</span></span>' + fim;
  }

  /* fundo do rodape: o espaco que a barra cobre ganha a mesma cor do ultimo bloco do rodape */
  var fundoRodape = null;
  function corDoRodape() {
    if (fundoRodape !== null) return fundoRodape;
    fundoRodape = '';
    /* ultimo bloco VISIVEL: o rodape termina com secoes so de script (altura zero) */
    var secs = document.querySelectorAll('.footer-group > *'), ult = null;
    for (var k = secs.length - 1; k >= 0 && !ult; k--) if (secs[k].offsetHeight > 0) ult = secs[k];
    if (!ult) return fundoRodape;
    var els = [ult].concat([].slice.call(ult.querySelectorAll('*'), 0, 8));
    for (var i = 0; i < els.length; i++) {
      var c = getComputedStyle(els[i]).backgroundColor, cc = String(c).split(' ').join('');
      if (c && c !== 'transparent' && !(cc.indexOf('rgba(') === 0 && cc.slice(-3) === ',0)')) { fundoRodape = c; break; }
    }
    return fundoRodape;
  }

  function desenharBarra() {
    if (!BARRA) return;
    var e = ultimo ? estadoBarra(ultimo.cart, ultimo.m) : null;
    if (!e) {
      if (barEl) { barEl.remove(); barEl = null; }
      sigBar = ''; nAntes = -1;
      raiz.classList.remove('sc-bf-bar-on');
      return;
    }
    var cel = !!(mqCel && mqCel.matches);
    var html = htmlBarra(e, ultimo.cart, ultimo.m, cel);
    var novo = !barEl;
    if (novo) {
      barEl = document.createElement('div');
      barEl.className = 'sc-bf-bar is-out';
      barEl.setAttribute('data-sc-bf-bar', '');
      document.body.appendChild(barEl);
    }
    if (html !== sigBar) {
      barEl.innerHTML = html; sigBar = html;
      var sp = barEl.querySelector('[data-curto]');
      if (sp && sp.scrollWidth > sp.clientWidth + 1) sp.textContent = sp.getAttribute('data-curto');
      var clica = e.n > 0;
      barEl.setAttribute('data-n', String(e.n));
      if (clica) {
        barEl.setAttribute('data-clica', '');
        barEl.setAttribute('role', 'button');
        barEl.setAttribute('tabindex', '0');
        barEl.setAttribute('aria-label', e.n === 2 ? 'Escolher a 3ª peça grátis no carrinho' : 'Abrir o carrinho');
      } else {
        ['data-clica', 'role', 'tabindex', 'aria-label'].forEach(function (a) { barEl.removeAttribute(a); });
      }
      /* animacao so quando a quantidade sobe: o circulo novo "pula", o presente pulsa ao liberar */
      if (nAntes >= 0 && e.n > nAntes) {
        var alvo = e.n <= 2 ? barEl.querySelector('.sc-bf-bar__c[data-i="' + (e.n - 1) + '"]') : null;
        if (alvo) alvo.classList.add('pop');
        if (e.n === 2) { var gg = barEl.querySelector('.sc-bf-bar__g'); if (gg) gg.classList.add('pulso'); }
      }
      nAntes = e.n;
    }
    var fora = gavetaAberta();
    var mostra = !fora;
    if (novo) {
      /* entra deslizando no quadro seguinte */
      var abre = function () { if (barEl && !gavetaAberta()) barEl.classList.remove('is-out'); };
      if (window.requestAnimationFrame) window.requestAnimationFrame(function () { window.requestAnimationFrame(abre); }); else setTimeout(abre, 30);
    } else {
      barEl.classList.toggle('is-out', !mostra);
    }
    raiz.classList.toggle('sc-bf-bar-on', mostra);
    if (mostra) {
      var alt = (parseFloat(getComputedStyle(barEl).bottom) || 0) + barEl.offsetHeight;
      var v = Math.round(alt) + 'px';
      if (raiz.style.getPropertyValue('--scbf-bar') !== v) raiz.style.setProperty('--scbf-bar', v);
      var fr = corDoRodape();
      if (fr && raiz.style.getPropertyValue('--scbf-rodape') !== fr) raiz.style.setProperty('--scbf-rodape', fr);
    }
  }

  function abrirGaveta(irEscolha) {
    var g = document.querySelector('cart-drawer');
    if (!g || typeof g.show !== 'function') { window.location.href = '/cart'; return; }
    g.show();
    if (!irEscolha) return;
    /* com 2 pecas: leva direto para o seletor da gratis, depois que a gaveta abriu */
    var t0 = Date.now();
    (function tenta() {
      var alvo = document.querySelector('cart-drawer .sc-bf-pk');
      if (alvo && g.hasAttribute('open')) {
        setTimeout(function () { try { alvo.scrollIntoView({ block: 'center', behavior: 'smooth' }); } catch (e) {} }, 350);
        return;
      }
      if (Date.now() - t0 < 3000) setTimeout(tenta, 120);
    })();
  }
  if (BARRA) {
    document.addEventListener('click', function (ev) {
      var b = ev.target && ev.target.closest ? ev.target.closest('[data-sc-bf-bar]') : null;
      if (!b || !b.hasAttribute('data-clica')) return;
      ev.preventDefault();
      abrirGaveta(b.getAttribute('data-n') === '2');
    });
    document.addEventListener('keydown', function (ev) {
      var b = ev.target;
      if (!b || !b.hasAttribute || !b.hasAttribute('data-sc-bf-bar') || !b.hasAttribute('data-clica')) return;
      if (ev.key !== 'Enter' && ev.key !== ' ') return;
      ev.preventDefault();
      abrirGaveta(b.getAttribute('data-n') === '2');
    });
    document.addEventListener('animationend', function (ev) {
      var t = ev.target;
      if (t && t.classList && t.closest && t.closest('[data-sc-bf-bar]')) t.classList.remove('pop', 'pulso');
    });
  }

  /* ---------- partida ---------- */
  function ligar() {
    try {
      window.theme.pubsub.subscribe(window.theme.pubsub.PUB_SUB_EVENTS.cartUpdate, function (ev) {
        if (ev && ev.source === 'sc-bf') return;
        agendar();
      });
    } catch (e) {}
    ['cart:refresh', 'cart:build', 'cart:change'].forEach(function (nome) {
      document.addEventListener(nome, function () { if (!meu) agendar(); });
    });
    window.addEventListener('pageshow', function (e) { if (e.persisted) agendar(); });

    /* o tema troca o HTML do painel a cada cart:refresh. O observador recoloca card, vaga e
       etiquetas no mesmo quadro (sem piscar); o intervalo fica de rede de seguranca.
       desenhar() so mexe no DOM quando falta algo, entao a volta do observador para ai. */
    var quadro = 0;
    function logo() {
      if (quadro || !ultimo) return;
      var vez = function () { quadro = 0; desenhar(); };
      quadro = window.requestAnimationFrame ? window.requestAnimationFrame(vez) : setTimeout(vez, 16);
    }
    var gav = document.querySelector('cart-drawer');
    if (gav && window.MutationObserver) new MutationObserver(logo).observe(gav, { childList: true, subtree: true });
    /* barra do rodape: some na hora em que qualquer gaveta abre (atributo open) */
    if (BARRA && window.MutationObserver) new MutationObserver(function () { if (ultimo) desenharBarra(); })
      .observe(document.body, { attributes: true, attributeFilter: ['open'], subtree: true });
    setInterval(function () { if (ultimo) desenhar(); }, 500);
    agendar();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ligar);
  else ligar();

  window.scEscadaBF = { conferir: agendar, valorPago: function (c) { return valorPago(c); } };
})();